import { Api } from '../api';
import { accounts } from '../endpoints';
import type { ApiPaginate, ApiResponse } from '../../models';
import type {
  AccountBalanceResponse,
  GetCardAccountBalanceReportRequest,
  GetCardAccountBalanceReportResponse,
  AccountRequest,
  AccountResponse,
  AccountByIdResponse,
  AccountUpdateDetailsRequest,
  AccountUpdateRequest,
  declinedAuthsSubscriptionRequest,
  minimalBalanceSubscriptionRequest,
  GetPaymentAccountBalanceReportResponse,
  GetPaymentAccountBalanceReportRequest,
  AccountForIntegrationsRequest,
  AccountForIntegrationsResponse,
} from './models';

export class AccountsApi extends Api {
  static getAccounts = (request?: AccountRequest, signal?: AbortSignal) =>
    this.get<ApiResponse<AccountResponse[]>>({ url: accounts.getAccounts(), queryParams: request, signal });

  static getAccountsForIntegrations = (request?: AccountForIntegrationsRequest, signal?: AbortSignal) =>
    this.get<ApiPaginate<AccountForIntegrationsResponse[]>>({ url: accounts.getAccountsForIntegrations(), queryParams: request, signal });

  static getAccount = async (request: number, signal?: AbortSignal) => {
    const result = await this.get<ApiResponse<AccountByIdResponse>>({ url: accounts.getAccountById(), queryParams: { accountId: request }, signal });
    return result.data;
  };

  static updateDetails = async ({ request }: AccountUpdateRequest<AccountUpdateDetailsRequest>, signal?: AbortSignal) => {
    const result = await this.put<AccountUpdateDetailsRequest, ApiResponse<AccountByIdResponse>>({
      url: accounts.updateDetails(),
      data: request,
      signal,
    });
    return result.data;
  };

  static minimalBalanceSubscription = async (request: minimalBalanceSubscriptionRequest, accountId: number) => {
    const result = await this.post<minimalBalanceSubscriptionRequest, ApiResponse<AccountByIdResponse>>({
      url: accounts.updateMBSubscription(accountId),
      data: request,
    });
    return result.data;
  };

  static declinedAuthsSubscription = async (request: declinedAuthsSubscriptionRequest, userId: number) => {
    const result = await this.post<declinedAuthsSubscriptionRequest, ApiResponse<AccountByIdResponse>>({
      url: accounts.updateDASubscription(userId),
      data: request,
    });
    return result.data;
  };

  static getCardAccountBalanceReport = (request: GetCardAccountBalanceReportRequest, signal?: AbortSignal) =>
    this.get<ApiPaginate<GetCardAccountBalanceReportResponse[]>>({ url: accounts.getCardAccountBalanceReport(), queryParams: request, signal });

  static getPaymentAccountBalanceReport = (request: GetPaymentAccountBalanceReportRequest, signal?: AbortSignal) =>
    this.get<ApiPaginate<GetPaymentAccountBalanceReportResponse[]>>({ url: accounts.getPaymentAccountBalanceReport(), queryParams: request, signal });

  static getBalance = (accountId: number) =>
    this.get<ApiResponse<AccountBalanceResponse>>({ url: accounts.getBalance(accountId), queryParams: { accountId } });
}
